import React from 'react';
import { ApprovalStatus } from '../../main/components/Preset/models';
import { Role } from '../../../features/authentication/types/auth.types';
import { environment } from '../../../Config';

const ApproveButton = ({
  id,
  username,
  label,
  role,
  needsDiscountApproval,
}: {
  id: number;
  username: string;
  label: string;
  role: Role;
  needsDiscountApproval: boolean;
}) => {
  const handleSubmit = async () => {
    await approvePreset();

    if (role === Role.CRO) {
      console.log('needsDiscountApproval', needsDiscountApproval);

      await Promise.all([notifyApprove(), needsDiscountApproval ? notifyApproverAfterCro() : null]);
    } else {
      await notifyApprove();
    }

    window.location.href = '/';
  };

  const approvePreset = async () => {
    try {
      await fetch(
        `https://prod-15.eastus.logic.azure.com:443/workflows/935c0d0a0c654359b40a954cc118770b/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=BzAcr3yCy2ijN2IrSloKghn27qZenIWePKTcWkyZwzA`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: id,
            newStatus: role === Role.CRO ? ApprovalStatus.APPROVED_CRO : ApprovalStatus.APPROVED_APPROVER,
          }),
        }
      );
    } catch (error) {
      console.error('Error approving preset:', error);
    }
  };

  const notifyApproverAfterCro = async () => {
    try {
      const response = await fetch(
        environment === 'dev'
          ? `https://prod-49.eastus.logic.azure.com:443/workflows/500d66dea1e14e34ad6475bdba3e8524/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=hEzrJ8q_HIzncEXByM5t9PFlbusdvMfxk71qc4fpXzE`
          : `https://prod-51.eastus.logic.azure.com:443/workflows/9ed1fdf53189453384e673260103bc0b/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=-d19FgtcTxJDHjC0f2Wt5vveWariiMkNSbraTHJm8Gw`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: id,
            email: username,
            label: label,
          }),
        }
      );
    } catch (error) {
      console.error('Error notifying approval:', error);
    }
  };

  const notifyApprove = async () => {
    try {
      const response = await fetch(
        'https://prod-63.eastus.logic.azure.com:443/workflows/fb031a87ddcc4fee89a2a78a306662d9/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=sqmR4K3nazu8K5dwq5gj4dYQ9nVGJUp-BRMkurGx6w0',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: id,
            email: username,
            label: label,
            status:
              role === Role.CRO
                ? needsDiscountApproval
                  ? 'waiting discount approval'
                  : 'approved export'
                : 'approved discount',
          }),
        }
      );
    } catch (error) {
      console.error('Error notifying approval:', error);
    }
  };

  return (
    <div>
      <button onClick={handleSubmit} style={buttonStyles}>
        Approve
      </button>
    </div>
  );
};

// Define styles for the button
const buttonStyles = {
  height: '5.6vh',
  width: '24vh',
  fontSize: '1.6vh',
  fontWeight: '700',
  color: '#ffffff',
  backgroundColor: 'rgba(0, 171, 155, 1)', // Blue color
  border: 'none',
  borderRadius: '1.6vh',
  cursor: 'pointer',
  transition: 'background-color 0.3s, transform 0.2s',
  outline: 'none',
};

export default ApproveButton;
